import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';

const RefundPolicy = () => {
  const [activeLink, setActiveLink] = useState('');

  // This effect runs once when the component mounts
  useEffect(() => {
    // Get the current path from the URL (e.g., "/privacy-policy")
    const currentPath = window.location.pathname;
    setActiveLink(currentPath);
  }, []); // The empty array ensures this effect runs only once

  return (
    <>
      <Helmet>
        <meta name="title" content="Refund Policy | Get Next Visa - AI Powered Student Visa Report" />
        <title>Refund Policy | Get Next Visa - AI Powered Student Visa Report</title>
        <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
      </Helmet>

      <div className="privacy-banner">
        <div className="privacy-container">
          <nav className="privacy-nav">
            <ul>
              {/* Conditionally apply the 'active' class based on the current path */}
              <li><a href="/privacy-policy" className={activeLink === '/privacy-policy' ? 'active' : ''}>PRIVACY POLICY</a></li>
              <li><a href="/terms" className={activeLink === '/terms' ? 'active' : ''}>TERMS OF SERVICE</a></li>
              <li><a href="/refund-policy" className={activeLink === '/refund-policy' ? 'active' : ''}>REFUND POLICY</a></li>
            </ul>
          </nav>
          <main className="privacy-content">
            <header className="privacy-header">
              <h1>Refund and Cancellation Policy got GET NEXT VISA</h1>
              <p><b>Last updated: July 16, 2025</b></p>
            </header>


            <section className="privacy-section">
              <h2>1. Scope</h2>
              <ul>
                <li><b>Digital Service Only:</b> We provide AI‑generated reports and counseling
                  bookings—no physical products are delivered.</li>
                <li><b>No Cash Refunds:</b> We do not refund payments back to credit cards or
                  bank accounts. Eligible issues are remedied via coupon credit only.</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>2. Scope of Refunds & Adjustments</h2>
              <ul>
                <p>You may raise a support ticket (via your portal’s Raise a Ticket) within 24 hours
                  of payment or report generation if any of the following occur:</p>
                <li>I<b>naccurate Data in Report</b>
                  – Your report contains material errors or omissions in the data we
                  provided.
                </li>
                <li><b>Report Not Generated</b>
                  – Payment was successfully deducted but no report was created or
                  delivered..</li>

                <li><b>Counseling Not Booked</b>
                  – You paid for a counseling session but the booking did not complete or
                  confirm.
                </li>
                <li><b>Technical Error Codes</b>
                  – You received an error (e.g., “State mismatch,” API failures) preventing
                  report generation or booking.
                </li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>3. Error Resolution & Coupon Issuance</h2>
              <ul>
                <h3>1. Ticket Submission
                </h3>
                <li>Submit via Raise a Ticket in your portal within 24 hours. </li>
                <li>Include your Order Number, date/time, and a description of the
                  issue.</li>
                <h3>2. Review Period</h3>
                <li>We will acknowledge your ticket within 24 hours and investigate</li>
                <h3>3. Coupon Credit</h3>
                <li>If we confirm an eligible issue, we will issue a coupon for the full
                  amount you paid.
                </li>
                <li>Coupon is delivered within 48 hours of ticket submission.
                </li>
                <li>Coupon expires as stated in your coupon notification (typically
                  30 days).</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>4. Cancellation Policy</h2>
              <ul>
                <li><b>Pre‑Generation Cancellation:</b> Raise a ticket within 24 hours of purchase
                  before report generation or booking; eligible orders will be canceled and
                  a coupon issued.
                </li>
                <li><b> Post‑Generation/Booking: </b>Once your report is delivered or your session
                  is confirmed, cancellation is not available—please use the ticket
                  process above if there’s an error.
                </li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>5. How to Submit a Ticket</h2>
              <ul>
                <h3>1. Log in at <a href='https://getnextvisa.com/Contact'>https://getnextvisa.com</a>

                </h3>
                <h3>2. Click Raise a Ticket</h3>
                <h3>3. Provide:</h3>
                <li> Order Number</li>
                <li>Date/Time of purchase or generation</li>
                <h3>2. Review Period</h3>
                <li>Detailed description of the problem</li>
                <h3>4. Submit and await our acknowledgment (within 24 hours).</h3>

              </ul>
            </section>


            <section className="privacy-section">
              <h2>6. Policy Changes
              </h2>
              <ul>
                <p>We may update this policy as needed. Material changes will be posted with a
                  new “Last updated” date, and registered users will be notified by email.</p>
              </ul>
            </section>


<section className="privacy-section">
              <h2>7. Contact Us</h2>

              <ul>
                <li>Email: <a href="mailto:privacy@gnvisa.com">privacy@getnextvisa.com</a></li>
                <li>Support Ticket: <a href="https://getnextvisa.com/Contact">https://getnextvisa.com/Contact</a></li>
              </ul>

            </section>

            <p>Thank you for your understanding. We’re committed to delivering accurate,
reliable services and will do our best to make things right if an error occurs.</p>
          </main>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default RefundPolicy;